import { Box, styled } from '@mui/material';

export const Row = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
});
